define('app/sdc/progress/args/sdc-progress-args',["$q", "factory!selcomm:progress"], function ($q, progressFactory) {
	return {
		restrict: "A",
		template: null,
		controller: {
			defaults: {
				parseProgress: function parseProgress(locals) {
					return locals.$progress;
				}
			},
			bind: {
				"expr": "&sdcProgressArgs",
				"parseProgress": "&?"
			},
			constructor: ["$self", "$watch", "$attrs", function (vm, $watch, $attrs) {
				var currentPromise;
				function update(val) {
					var determinate = angular.isNumber(val) && !isNaN(val);
					$attrs.$set("mdMode", determinate ? "determinate" : "indeterminate");
					$attrs.$set("value", determinate ? val : null);
				}
				function watchExprFn(val) {
					currentPromise = null;
					if ($q.isQ(val)) {
						update(NaN);
						var thisPromise = currentPromise = val.then(null, null, function (progress) {
							if (currentPromise === thisPromise) {
								progress = vm.parseProgress(progress);
							}
							if (progressFactory.isProgress(progress)) {
								progress = progress.progress === 1 ? undefined : newProgress.progress;
							}
							update(progress);
						}).finally(function () {
							if (currentPromise === thisPromise) {
								update(100);
							}
						});
					}
					if (angular.isNumber(val) && !isNaN(val)) {
						vm.mode = "determinate";
						vm.value = val;
					}
					else if (val) {
						update(NaN);
					}
					else {
						update(100);
					}
				}
				$watch(vm.expr, watchExprFn);
			}]
		}
	};
});
